interface IdentifiableEntity {
  id: string;
}

/**
 * Removes entities with an id not in the specified list
 */
export function filterByIds<T extends IdentifiableEntity>(entities: T[], ids: string[]): T[] {
  return ids.reduce<T[]>((results, id) => {
    const result = entities.find((entity) => entity.id === id);

    if (result) {
      results.push(result);
    }

    return results;
  }, []);
}

/**
 * Find entity with an id in the specified list
 */
export function findById<T extends IdentifiableEntity>(entities: T[], id: string | undefined): T | undefined {
  return entities.find((item) => item.id === id);
}

export function getIds<T extends IdentifiableEntity>(entities: T[]): IdentifiableEntity["id"][] {
  return entities.map((entity) => entity.id);
}
